import React from 'react';

import { TWO_FACTOR_SIGN_IN } from '@personal-trainer-app/shared';

import type { TwoFactorMethodSwitchProps } from './TwoFactorMethodSwitch.types';

import { Text, TextLink } from '@/components/ui';

/**
 * The way to the other second factor: "Can't use your app? Use a recovery
 * code instead", and back. One field shows at a time, so it's always clear
 * what's being asked.
 */
export function TwoFactorMethodSwitch({
  method,
  onSwitch,
  disabled = false,
  className = '',
}: TwoFactorMethodSwitchProps): React.JSX.Element {
  const words = TWO_FACTOR_SIGN_IN[method];

  return (
    <Text variant="body-sm" color="muted" className={className}>
      <TextLink lead={words.switchLead} onClick={onSwitch} disabled={disabled}>
        {words.switchLabel}
      </TextLink>
    </Text>
  );
}

export default TwoFactorMethodSwitch;
